/**
 * @generated SignedSource<<725ac42f276252bc8678723c6be351ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useEmailValidationCheckQuery$variables = {
  email: string;
};
export type useEmailValidationCheckQuery$data = {
  readonly validateEmailInput: {
    readonly normalized: string | null;
    readonly ok: boolean;
    readonly reason: string | null;
    readonly suggestion: string | null;
  };
};
export type useEmailValidationCheckQuery = {
  response: useEmailValidationCheckQuery$data;
  variables: useEmailValidationCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "EmailValidationResult",
    "kind": "LinkedField",
    "name": "validateEmailInput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "normalized",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "suggestion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEmailValidationCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmailValidationCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8f62951c2537c5ff2f9fcee298a7386a",
    "id": null,
    "metadata": {},
    "name": "useEmailValidationCheckQuery",
    "operationKind": "query",
    "text": "query useEmailValidationCheckQuery(\n  $email: String!\n) {\n  validateEmailInput(email: $email) {\n    ok\n    normalized\n    suggestion\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "62e5666ea078d6c7101dcb13ab0be796";

export default node;
